module.exports = __webpack_public_path__ + "img/houseHomeBottom.d60599cf.jpeg";